/**
 * Card widget component
 * 
 */

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

// Functions

import Helpers from '../../utils/functions/helpers';
import Event from '../../utils/functions/analytics';

// Components

import Image from '../image/image';

export default class CardWidget extends PureComponent {

	handleClick(event) {
		
		Event.navigation({ action: 'widget', label: event.currentTarget.getAttribute('aria-label') });
	}

	render() {

		const { title, text, link, image } = this.props.data;
		
		const url = Helpers.linkResolver(link);

		if (url === undefined) {

			return (

				<section className="card card-widget">
					<div className="card-wrapper">
						<figure className="card-image"><Image data={image} classes="cover lazyloaded"/></figure>
						<div className="card-details">
							<h3>{title}</h3>
							<p>{text}</p>
						</div>
					</div>
				</section>
			);
		}
		else {

			return (

				<section className="card card-widget">
					<Link to={url} className="card-anchor" aria-label={title} onClick={this.handleClick}>
						<figure className="card-image card-flux"><Image data={image} classes="cover lazyloaded"/></figure>
						<div className="card-details">
							<h3>{title}</h3>
							<p>{text}</p>
						</div>
					</Link>
				</section>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/cards/card-widget.js